import { createTheme as createMuiTheme, responsiveFontSizes, Theme } from '@mui/material/styles';
import { baseThemeOptions } from './base-theme-options';
import { darkThemeOptions } from './dark-theme-options';
import { lightThemeOptions } from './light-theme-options';

type ThemeConfig = {
  mode: 'dark' | 'light';
  direction: 'ltr' | 'rtl';
  responsiveFontSizes: boolean;
};

export const createTheme = (config: ThemeConfig): Theme => {
  let theme = createMuiTheme(baseThemeOptions as any, config.mode === 'dark' ? darkThemeOptions : lightThemeOptions, {
    palette: {
      background: {
        default: config.mode === 'dark' ? '#0B0F19' : '#F9FAFC',
      },
    },
    direction: config.direction,
  });

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
